import { useTranslation } from 'react-i18next'
import { SansText } from '@velasca/ui/sans-text'
import {
  StyledCheckbox,
  StyledInfoButton,
  Wrapper,
} from './IsGiftOption.styles'
import type { IsGiftOptionProps } from './IsGiftOption.types'

export const IsGiftOption = ({
  setIsGiftOrder,
}: IsGiftOptionProps): JSX.Element => {
  const { t } = useTranslation('global')

  return (
    <Wrapper>
      <StyledCheckbox id="isGiftOrder" onCheckedChange={setIsGiftOrder}>
        <SansText
          fontWeight="500"
          as="label"
          color="primary"
          size="md"
          htmlFor="isGiftOrder"
        >
          {t('is_gift_order')}
          <StyledInfoButton text={t('gift_order_popover_message')} />
        </SansText>
      </StyledCheckbox>
    </Wrapper>
  )
}
